import { __assign, __rest } from "tslib";
import React, { memo } from 'react';
var Line = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, _c = _a.stroke, stroke = _c === void 0 ? 1 : _c, props = __rest(_a, ["color", "stroke"]);
    return (React.createElement("line", __assign({}, props, { style: { stroke: color, strokeWidth: stroke } })));
};
export default memo(Line);
